import { render, staticRenderFns } from "./SportsTherapy.vue?vue&type=template&id=338e9d43"
import script from "./SportsTherapy.vue?vue&type=script&lang=js"
export * from "./SportsTherapy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports